import { API_BASE_URL } from '../config/api';

/**
 * Fetch the current user's agent ID from /auth/me.
 * Falls back to user.id from auth context if available.
 */
export async function getAgentId(apiCall, user) {
  try {
    const res = await apiCall(`${API_BASE_URL}/auth/me`);
    const id = res?.user?.id;
    if (id !== undefined && id !== null) return id;
  } catch {}
  if (user?.id !== undefined && user?.id !== null) return user.id;
  return null;
}
